import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19b6438c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scene.less?vue&type=style&index=0&id=19b6438c&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=19b6438c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6438c",
  null
  
)

export default component.exports